import { jsx } from 'react/jsx-runtime';
import { Link as Link$1 } from '@elseu/sdu-titan';

/**
 * The Link component
 *
 * @param {LinkProps} props - The props for the Link component.
 * @returns {JSX.Element} The Link component.
 */
var Link = function (_a) {
  var children = _a.children,
    to = _a.to,
    className = _a.className,
    isExternal = _a.isExternal,
    suffixAdornment = _a.suffixAdornment;
  var rel = isExternal ? 'noopener noreferrer' : undefined;
  var target = isExternal ? '_blank' : undefined;
  return jsx(Link$1, {
    to: to,
    className: className,
    suffixAdornment: suffixAdornment,
    rel: rel,
    target: target,
    children: children
  });
};

export { Link };
//# sourceMappingURL=Link.js.map
